import { IconPencil } from '@tabler/icons-react';
import { Box, IconButton, Stack, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import CusInput from '../../../../../components/material-ui/CusInput';
import BtnTrash from '../../../../../components/bonus/ui/BtnTrash';
import { useTranslation } from 'react-i18next';
import CurrencySelect from '../../../../../components/shared/CurrencySelect';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import BtnEdit from '../../../../../components/bonus/ui/BtnEdit';

export default function CollectionRow({
  collection,
  selectCollectionId,
  setSelectCollectionId,
  currentNameRef,
  setEditInfo,
  currentCollectionRef,
  setOpenDelete
}) {
  const { t } = useTranslation();

  const collectionCurrencies = collection.currencyList || [];
  const isSelect = collection.id == selectCollectionId;

  const onEditClick = (e) => {
    e.stopPropagation();
    setSelectCollectionId(collection.id);
    setEditInfo({ ...collection });
  };

  return (
    <TableRow
      key={collection.id}
      selected={isSelect}
      onClick={() => {
        isSelect ? setSelectCollectionId(null) : setSelectCollectionId(collection.id);
      }}
      ref={isSelect ? currentCollectionRef : undefined}>
      <MyTableCell isLess>
        <Stack gap={0.25}>
          <Stack display={'flex'} direction={'row'} gap={1}>
            <Typography sx={{ width: '100%', px: 1 }}>{collection.name}</Typography>

            <BtnEdit
              iconSize={16}
              sx={{ minWidth: 40, height: 26, padding: 0.5 }}
              onEditClick={onEditClick}
            />

            <BtnTrash
              iconSize={16}
              sx={{ minWidth: 40, height: 26, padding: 0.5 }}
              onDelete={(e) => {
                e.stopPropagation();
                setOpenDelete(collection.id);
              }}
            />
          </Stack>

          <Typography fontSize={12} color="textSecondary" px={1} lineHeight={'120%'}>
            {collectionCurrencies?.length == 0
              ? t('Any currency')
              : collectionCurrencies?.join(',')}
          </Typography>
        </Stack>
      </MyTableCell>
    </TableRow>
  );
}
